module.exports = __webpack_public_path__ + "img/7house05.a772fea4.jpg";